import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

import { APP_URLS } from '../../providers/constant';

@Injectable({
  providedIn: 'root'
})
export class ForgotPasswordService {

  private authApiUrl = `${APP_URLS.WEB_API_URL}`;

  constructor(
    private http: HttpClient
  ) { }

  public forgotPassword(authRequest): Observable<any> {
    return this.http.post<any>(`${this.authApiUrl}/users`, authRequest);
  }

}
